/* FansBRANDS Help Center V19 - progressive order tracking */
(function(){
  'use strict';

  var root=document.getElementById('fbh');
  if(!root || root.dataset.fbhTrackingReady==='1')return;
  var core=window.FansBrandsOrderSupport;
  if(!core){
    console.error('FansBRANDS order support core is missing.');
    return;
  }
  root.dataset.fbhTrackingReady='1';

  function singleOpen(selector){
    root.querySelectorAll(selector).forEach(function(item){
      item.addEventListener('toggle',function(){
        if(!item.open)return;
        root.querySelectorAll(selector).forEach(function(other){if(other!==item)other.open=false;});
      });
    });
  }
  singleOpen('.quick-grid > details.card');
  singleOpen('.topics > details.topic');

  var api=root.dataset.trackingApi||'';
  var whatsappUrl=root.dataset.whatsappUrl||'';
  var form=document.getElementById('fbhTrackForm');
  if(!form)return;

  var primaryType=document.getElementById('fbhPrimaryType');
  var primaryWrap=document.getElementById('fbhPrimaryValueWrap');
  var primaryValue=document.getElementById('fbhPrimaryValue');
  var primaryLabel=document.getElementById('fbhPrimaryValueLabel');
  var primaryHelp=document.getElementById('fbhPrimaryValueHelp');
  var primaryChoices=[].slice.call(form.querySelectorAll('[data-track-primary-choice]'));

  var secondaryStep=document.getElementById('fbhSecondaryStep');
  var secondaryType=document.getElementById('fbhSecondaryType');
  var secondaryWrap=document.getElementById('fbhSecondaryValueWrap');
  var secondaryValue=document.getElementById('fbhSecondaryValue');
  var secondaryLabel=document.getElementById('fbhSecondaryValueLabel');
  var secondaryHelp=document.getElementById('fbhSecondaryValueHelp');
  var secondaryChoices=[].slice.call(form.querySelectorAll('[data-track-secondary-choice]'));

  var submit=document.getElementById('fbhTrackSubmit');
  var msg=document.getElementById('fbhTrackMsg');
  var result=document.getElementById('fbhTrackResult');

  var requestController=null;
  var requestSerial=0;
  var requestTimer=null;

  function clearPressed(buttons){
    buttons.forEach(function(button){
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed','false');
    });
  }

  function setPressed(buttons,type){
    buttons.forEach(function(button){
      var selected=button.dataset.trackPrimaryChoice===type || button.dataset.trackSecondaryChoice===type;
      button.classList.toggle('is-selected',selected);
      button.setAttribute('aria-pressed',selected?'true':'false');
    });
  }

  function abortRequest(){
    requestSerial++;
    if(requestController)requestController.abort();
    requestController=null;
    clearTimeout(requestTimer);
    requestTimer=null;
  }

  function resetFeedback(){
    abortRequest();
    submit.disabled=false;
    submit.textContent='OVĚŘIT OBJEDNÁVKU';
    msg.hidden=true;
    msg.textContent='';
    result.hidden=true;
    result.replaceChildren();
  }

  function configure(which,type){
    var meta=core.fieldMeta[type];
    var input=which==='primary'?primaryValue:secondaryValue;
    var label=which==='primary'?primaryLabel:secondaryLabel;
    var help=which==='primary'?primaryHelp:secondaryHelp;
    if(!meta)return;
    core.configureInput(input,type);
    label.textContent=meta.prompt;
    help.textContent=meta.hint;
    input.removeAttribute('aria-invalid');
  }

  function focusInput(input){
    if(!input)return;
    requestAnimationFrame(function(){
      try{input.focus({preventScroll:true});}catch(_){input.focus();}
      setTimeout(function(){input.scrollIntoView({block:'center',behavior:'smooth'});},80);
    });
  }

  function resetSecondary(primary){
    secondaryType.value='';
    secondaryWrap.hidden=true;
    secondaryValue.value='';
    submit.hidden=true;
    clearPressed(secondaryChoices);
    secondaryChoices.forEach(function(button){
      var type=button.dataset.trackSecondaryChoice;
      button.hidden=type===primary;
      var small=button.querySelector('small');
      if(small){
        if((primary==='order_number'&&type==='email')||(primary==='email'&&type==='order_number')) small.textContent='Doporučeno';
        else if(type==='phone') small.textContent='Včetně mezinárodní předvolby';
        else if(type==='postal_code') small.textContent='Doručovací nebo fakturační adresa';
      }
    });
  }

  function selectPrimary(type){
    resetFeedback();
    if(!core.fieldMeta[type]||['order_number','email'].indexOf(type)===-1)return;
    primaryType.value=type;
    setPressed(primaryChoices,type);
    configure('primary',type);
    primaryWrap.hidden=false;
    secondaryStep.hidden=false;
    resetSecondary(type);
    focusInput(primaryValue);
  }

  function selectSecondary(type){
    resetFeedback();
    if(!core.fieldMeta[type]||type===primaryType.value)return;
    secondaryType.value=type;
    setPressed(secondaryChoices,type);
    configure('secondary',type);
    secondaryWrap.hidden=false;
    submit.hidden=false;
    focusInput(secondaryValue);
  }

  primaryChoices.forEach(function(button){
    button.addEventListener('click',function(){selectPrimary(button.dataset.trackPrimaryChoice);});
  });
  secondaryChoices.forEach(function(button){
    button.addEventListener('click',function(){selectSecondary(button.dataset.trackSecondaryChoice);});
  });

  function onInput(){
    resetFeedback();
    this.removeAttribute('aria-invalid');
    if((this===primaryValue?primaryType.value:secondaryType.value)==='order_number'){
      var pos=this.selectionStart;
      this.value=core.normalize('order_number',this.value);
      try{this.setSelectionRange(pos,pos);}catch(_){}
    }
  }
  primaryValue.addEventListener('input',onInput);
  secondaryValue.addEventListener('input',onInput);

  function keyboardFocus(){root.classList.add('is-tracking-input-active');}
  function keyboardBlur(){
    setTimeout(function(){
      if(document.activeElement!==primaryValue&&document.activeElement!==secondaryValue){
        root.classList.remove('is-tracking-input-active');
      }
    },100);
  }
  [primaryValue,secondaryValue].forEach(function(input){
    input.addEventListener('focus',keyboardFocus);
    input.addEventListener('blur',keyboardBlur);
  });

  function showError(text,input){
    msg.textContent=text;
    msg.hidden=false;
    result.hidden=true;
    if(input){
      input.setAttribute('aria-invalid','true');
      focusInput(input);
    }else{
      msg.scrollIntoView({block:'nearest',behavior:'smooth'});
    }
  }

  form.addEventListener('submit',async function(event){
    event.preventDefault();
    if(requestController)return;
    resetFeedback();

    var first=primaryType.value;
    var second=secondaryType.value;
    if(['order_number','email'].indexOf(first)===-1){showError('Nejprve vyberte, zda chcete ověřovat číslem objednávky nebo e-mailem.');return;}
    if(!core.fieldMeta[second]||first===second){showError('Vyberte druhý údaj pro ověření.');return;}

    var a=core.validate(first,primaryValue.value);
    var b=core.validate(second,secondaryValue.value);
    if(a.error){showError(a.error,primaryValue);return;}
    if(b.error){showError(b.error,secondaryValue);return;}

    primaryValue.value=a.value;
    secondaryValue.value=b.value;
    var payload={}; payload[first]=a.value; payload[second]=b.value;

    var endpoint;
    try{
      endpoint=new URL(api);
      if(endpoint.protocol!=='https:'||/fansbrands-pontic-integration/i.test(endpoint.hostname)||/\/v1\/(ro|hu)\//i.test(endpoint.pathname))throw new Error();
    }catch(_){
      showError('Automatické ověření zatím není pro český obchod nastaveno. Kontaktujte zákaznickou podporu.');
      return;
    }

    var serial=++requestSerial;
    requestController=new AbortController();
    var timedOut=false;
    submit.disabled=true;
    submit.textContent='OVĚŘUJEME...';
    form.setAttribute('aria-busy','true');
    requestTimer=setTimeout(function(){timedOut=true;if(requestController)requestController.abort();},15000);

    try{
      var response=await fetch(endpoint.href,{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),
        signal:requestController.signal,credentials:'omit',cache:'no-store'
      });
      var data=await response.json();
      if(serial!==requestSerial)return;

      if(!response.ok||!data||data.ok!==true){
        if(response.status===404)showError(core.noMatchMessage(second));
        else if(response.status===429)showError('Příliš mnoho pokusů. Počkejte minutu a zkuste to znovu.');
        else showError(typeof data.message==='string'?data.message:'Objednávku nelze ověřit. Zkuste to později.');
        return;
      }

      root.classList.remove('is-tracking-input-active');
      if(document.activeElement&&typeof document.activeElement.blur==='function')document.activeElement.blur();
      core.renderOrder(result,data,{whatsappUrl:whatsappUrl});
      result.scrollIntoView({block:'nearest',behavior:'smooth'});
    }catch(error){
      if(serial!==requestSerial)return;
      if(timedOut)showError('Ověření trvá příliš dlouho. Zkuste to znovu nebo nás kontaktujte.');
      else if(error.name!=='AbortError')showError('Chyba připojení. Zkontrolujte internet a zkuste to znovu.');
    }finally{
      if(serial===requestSerial){
        clearTimeout(requestTimer);requestTimer=null;requestController=null;
        submit.disabled=false;submit.textContent='OVĚŘIT OBJEDNÁVKU';form.removeAttribute('aria-busy');
      }
    }
  });
})();
